module.exports = __webpack_public_path__ + "static/ambasador_katarzyna_pulawska-150524aadcc1aba97bddd4ea41068512.png";